import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Typography from '../../components/common/Typography';

import aiIcon01 from '../../asset/img/ai_assistant_icon_03.svg';
import { useSelector } from 'react-redux';
import AlertContext from '../../context/AlertContext';
import { useNavigate } from 'react-router-dom';

const AiAssistantBannerStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  border-radius: 16px;
  background: var(--GrayScale-100, #f5f5f5);
  height: 112px;
  align-items: center;
  flex: 2;
  align-self: stretch;

  .aiGrayBox {
    display: flex;
    gap: 5px;
    padding: 10px;
    justify-content: center;
    align-items: center;
    border-radius: 15px;
    background: rgba(84, 77, 92, 0.15);
  }
`;

const AiAssistantBanner = () => {
  /* ai 연말정산 세법 도우미 */
  const navigate = useNavigate();
  const { myInfo } = useSelector(state => state.myInfo);
  const { t: tMain } = useTranslation('main');
  const { t: tAiAsst } = useTranslation('aiAssistant');
  const {
    alertActions: { alertMessage },
  } = useContext(AlertContext);

  const goToAiAssistant = () => {
    const sessionId = sStorage.getItem('sessionId');
    const htmPerSabun = myInfo.htmPerSabun;
    const htmAlias = sStorage.getItem('htmAlias');

    if (!sessionId || !htmPerSabun || !htmAlias) {
      alertMessage(tAiAsst('error.msg01'), 'error');
      return;
    }

    navigate('/aiAsst');
  };

  return (
    <AiAssistantBannerStyled onClick={goToAiAssistant}>
      <div className={'aiGrayBox'}>
        <img src={aiIcon01} alt={'ai 세법 도우미'} style={{ width: '34px' }} />
        {/* <Typography {...{ variant: 'captionMedium', color: 'Primary-500' }}>
          {tMain('aiAssistantTitle02')}
        </Typography> */}
      </div>
      <Typography {...{ variant: 'body2Medium' }}>{tMain('aiAssistantDesc')}</Typography>
    </AiAssistantBannerStyled>
  );
};

export default AiAssistantBanner;
